// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3djvP","content":"styles_content__3jeUC"};